import { toFiltered } from '@modules/array/toFiltered'
import { Section } from '@modules/fhirQuestionnaire/Section'
import { ItemType } from '../fhirQuestionnaire/ItemType'

export function pickSections(textIds: readonly string[], allQuestionnaireSections: Section[]) {
  const pickedSections = toFiltered(allQuestionnaireSections, (section) =>
    textIds.map((textId) => textId.toLowerCase()).includes(section.text.toLowerCase())
  )
  const cleanedSections = toCleanedMissingReferenceQuestions(pickedSections)
  return cleanedSections
}

export function toCleanedMissingReferenceQuestions(sections: Section[]) {
  const linkIdsSet = constructLinkIdsSet(sections)
  sections.forEach((section) => {
    removeMissingReferencesInEnableWhen(section, linkIdsSet)
  })
  return sections
}

function removeMissingReferencesInEnableWhen(item: ItemType, linkIdsSet: Set<string>) {
  if (checkHasEnableWhen(item)) {
    const cleanedConditions = item.enableWhen.filter((condition) =>
      linkIdsSet.has(condition.question as string)
    )
    item.enableWhen = cleanedConditions
  }
  if (Array.isArray(item)) {
    item.forEach((item) => removeMissingReferencesInEnableWhen(item, linkIdsSet))
  }
  if ('item' in item && item.item) {
    removeMissingReferencesInEnableWhen(item.item as ItemType, linkIdsSet)
  }
}

function checkHasEnableWhen(
  item: ItemType
): item is { enableWhen: Record<string, unknown>[] } & Record<string, unknown> {
  return 'enableWhen' in item
}

export function constructLinkIdsSet(sections: Section[]) {
  const linkIdsSet = new Set<string>()
  sections.forEach((section) => {
    collectLinkIds(section, linkIdsSet)
  })
  return linkIdsSet
}

function collectLinkIds(item: ItemType, set: Set<string>) {
  if (checkHasLinkId(item) && !checkIsGroup(item) && !checkIsDisplay(item)) {
    set.add((item as { linkId: string } & ItemType).linkId)
  }
  if (Array.isArray(item)) {
    item.forEach((item) => collectLinkIds(item, set))
  }
  if ('item' in item && item.item) {
    collectLinkIds(item.item as ItemType, set)
  }
}

function checkHasLinkId(item: object): item is { linkId: string } & ItemType {
  return !!('linkId' in item && item.linkId)
}

function checkIsGroup(item: object): item is object {
  return 'type' in item && item.type === 'group'
}

function checkIsDisplay(item: object): item is object {
  return 'type' in item && item.type === 'display'
}
